module.exports = __webpack_public_path__ + "img/emerald-coast-high-angle.149ee55a.png";